module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel7-16657988e6d7add69d1037b0378cb1f3.jpg";